"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Swatch = void 0;
const react_1 = __importDefault(require("react"));
function Swatch(props) {
    return (react_1.default.createElement("div", { style: Object.assign({ height: 18, width: 18, maxWidth: 18, maxHeight: 18, minWidth: 18, minHeight: 18, margin: 1, backgroundColor: props.color.main, color: props.color.contrastText, flex: 1, borderRadius: 3 }, props.style) }));
}
exports.Swatch = Swatch;
exports.default = Swatch;
